export default "__VITE_ASSET__H77YVE4$__"